import { initOtelWeb } from "./lib/telemetry/otel";
import { initRUM } from "./lib/rum";
import { initSentry } from "./lib/sentry";
import { initPostHog } from "./lib/posthog";
import { initGA4, createGA4Provider } from "./lib/ga4";
import { initFacebookPixel, createFacebookPixelProvider } from "./lib/facebook-pixel";
import { registerAnalyticsProvider } from "@/lib/analytics";
import { createSupabaseAnalyticsProvider } from "@/lib/analytics-supabase-provider";
import { initPostHogReplayProvider } from "@/lib/posthog-replay";
import { isConsentGiven } from "@/lib/consent-manager";

// Initialize monitoring before anything else

// Sentry DSN warning — must be set in production for error tracking
if (!import.meta.env.VITE_SENTRY_DSN) {
  console.warn(
    '[Sentry] VITE_SENTRY_DSN not set — errors will NOT be tracked in production. See docs/runbooks/sentry-setup.md',
  );
}

// OpenTelemetry — distributed tracing
initOtelWeb();

// RUM — real user monitoring (Web Vitals, API timing, error rate, checkout funnel)
initRUM({ environment: import.meta.env.MODE });

initSentry();
import { initErrorCapture } from "./lib/error-capture";
initErrorCapture();
initPostHog();

// GA4
initGA4();
if (isConsentGiven("functional")) {
  registerAnalyticsProvider(createGA4Provider());
}

// Facebook Pixel
initFacebookPixel();
if (isConsentGiven("analytics")) {
  registerAnalyticsProvider(createFacebookPixelProvider());
}

// PostHog session replay: enriches analytics events with replay session IDs
initPostHogReplayProvider();

// Custom Supabase event ingestion
const consent = JSON.parse(localStorage.getItem("djayma_consent") ?? "null");
const apiUrl = import.meta.env.VITE_API_URL;
const validApiUrl = typeof apiUrl === "string" && apiUrl.startsWith("http") ? apiUrl : null;
if (consent?.analytics !== false && validApiUrl) {
  registerAnalyticsProvider(
    createSupabaseAnalyticsProvider(validApiUrl + "/api/analytics/events")
  );
}

import "./i18n";

import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);
